var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147.4 132.3",
    style: {
      enableBackground: "new 0 0 147.4 132.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EB0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,35.4h30v12.9h0.4c5.6-9.4,15.6-15.6,27-15.6c11.8,0,22.3,3.8,27.4,15.2c7.5-10,16.7-15.2,29.4-15.2 c30,0,33.2,22.7,33.2,40.7v56.3h-30.9V74.2c0-10.2-4.9-16.2-12.9-16.2c-13.2,0-14.5,10.2-14.5,25.4v46.1H58.3V76.1 c0-11.1-3.3-18-11.6-18c-11.1,0-15.8,6.4-15.8,25.6v45.9H0V35.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapsed);
export default __webpack_public_path__ + "static/media/logo_collapsed.6b976c6937c29962990eebf9d57dbcd0.svg";
export { ForwardRef as ReactComponent };